import { render, staticRenderFns } from "./edit_list.vue?vue&type=template&id=784a4654&scoped=true&"
import script from "./edit_list.vue?vue&type=script&lang=js&"
export * from "./edit_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784a4654",
  null
  
)

export default component.exports